module.exports = __webpack_public_path__ + "img/aej1n-66wvl.024.bf6662b0.png";